import React, { ReactElement } from 'react';
import { Button } from './Button.style';

export type TButtonProps = ReactElement<HTMLButtonElement>;

export default (props): TButtonProps => <Button {...props} />;
